import { Component, EventEmitter, Input, OnInit, Output, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'anterasoftware-kanban-production-machine-dialog',
  templateUrl: './kanban-production-machine-dialog.component.html',
  styleUrls: ['./kanban-production-machine-dialog.component.scss']
})
export class KanbanProductionMachineDialogComponent implements OnInit {
  
  public equipments: any[] = [];

  constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<KanbanProductionMachineDialogComponent>, @Inject(MAT_DIALOG_DATA) public data:any ) { 
    this.equipments = this.data?.equipments || [],
    console.log("KanbanProductionMachineDialogComponent equipments",this.equipments)
  }
  public editFlag = false;
  public form = this.fb.group({
    machineId: [''],
  })

  ngOnInit(): void {
    this.editFlag = this.data.panel ? true : false;
    this.setFormValues();
  }

  public setFormValues(): void{
    const values = {
      machineId: this.data?.machineId || '',
    };

    this.form.setValue(values);
  }

  public onSave(): void {
    const formValues = this.form.getRawValue();
    console.log("KanbanProductionMachineDialogComponent formValues",formValues)
    this.dialogRef.close(formValues);
  }

  public onClose(): void{
    this.dialogRef.close();
  }
}
